import { createFileRoute } from '@tanstack/react-router';
import { ChainCoursesOverviewPage } from '@/pages/chain/courses/overview/ChainCoursesOverviewPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/chain/learning')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['courses.readChainLearning'], redirectTo: '/chain/courses' }),
	component: ChainCoursesOverviewPage,
});
